<template>
    <TourLayout
        :config="config"
        @action-completed="emit('action-completed')"
    >
        <div class="grid grid-cols-4 gap-4">
            <div
                v-for="(icon, index) in icons"
                :key="index"
                :class="getOpacityClass(index)"
                class="flex items-center justify-center p-4 surface-elevated rounded-card-md shape-brand-base"
            >
                <PhIcon
                    weight="duotone"
                    :icon="icon"
                    :size="32"
                />
            </div>
        </div>
    </TourLayout>
</template>

<script setup>
    import PhIcon from '@/components/app/PhIcon.vue'
    import TourLayout from './TourLayout.vue'

    const emit = defineEmits(['action-completed'])

    const versionStore = useVersionStore()

    const props = defineProps({
        config: Object,
    })

    const { version } = storeToRefs(versionStore)

    const icons = [
        'newspaper',
        'calendar-dots',
        'users',
        'books',
        'megaphone',
        'coffee',
        'clock-user',
        'chalkboard-teacher',
        'backpack',
        'bell',
        'soccer-ball',
        'medal',
    ]

    const primaryColor = computed(() => get(version.value, 'primary_color'))

    const getOpacityClass = (index) => {
        const rowIndex = Math.floor(index / 4)
        if (rowIndex === 1) {
            return 'opacity-60'
        }
        if (rowIndex === 2) {
            return 'opacity-20'
        }
        return ''
    }
</script>
